export default __webpack_public_path__ + "static/media/meter-icon.b49056f3.svg";